import gql from 'graphql-tag';

export const Good360EvidenceCreateMutation = gql`
	mutation Good360EvidenceCreateMutation($values: Good360EvidenceCreateInput!) {
		results: good360EvidenceCreate(values: $values) {
			id
			localId
			type
			startDate
			endDate
		}
	}
`;
